// @/services/content/store/modules/carbon-accounting-add-drawer.js
export class CarbonAccountingAddDrawerHandler {
  constructor(store) {
    this.store = store;
  }

  /**
   * Get Carbon Accounting Add Drawer content by locale
   * @param {string} locale Locale to get content for
   * @returns {Object|null} Content or null if not found
   */
  getContent(locale = 'en') {
    // Try requested locale first
    const localeContent = this.store.state.data.carbonAccountingAddDrawer?.[locale];
    if (localeContent) return localeContent;
    
    // Fall back to English if different locale was requested
    if (locale !== 'en') {
      return this.store.state.data.carbonAccountingAddDrawer?.['en'] || null;
    }
    
    return null;
  }
}